function isScrolledIntoView(elem) {
  var $elem = $(elem)
  var $window = $(window)

  var docViewTop = $window.scrollTop()
  var docViewBottom = docViewTop + $window.height()

  var elemTop = $elem.offset().top
  var elemBottom = elemTop + $elem.height()

  return elemBottom <= docViewBottom && elemTop >= docViewTop
}

function counter($elem) {
  var $this = $elem.find('.counter-input')
  if (!$this.hasClass('animated')) {
    var number = $this.data('value').toString()
    if (number.match(/^\d+(,\d+)?$/)) {
      $this.empty()
      var numArray = number.split('')

      for (var i = 0; i < numArray.length; i++) {
        if (numArray[i] == '0') {
          $this.append(
            '<span class="digit-con test"><span class="digit' +
              i +
              '">9<br>8<br>7<br>6<br>5<br>4<br>3<br>2<br>1<br>0<br></span></span>'
          )
        } else if (numArray[i] !== ',') {
          $this.append(
            '<span class="digit-con"><span class="digit' +
              i +
              '">0<br>1<br>2<br>3<br>4<br>5<br>6<br>7<br>8<br>9<br></span></span>'
          )
        } else {
          $this.append(
            '<span class="digit-con"><span class="digit' +
              i +
              '">,</span></span>'
          )
        }
      }

      var increment = $this.find('.digit-con').outerHeight()
      var speed = 1500

      for (var j = 0; j < numArray.length; j++) {
        if (numArray[j] == '0') {
          numArray[j] = '9'
        }
        $this
          .find('.digit' + j)
          .animate({ top: -(increment * numArray[j]) }, speed)
      }

      $this
        .find('.digit-con:nth-last-child(3n+4)')
        .after('<span class="comma">.</a>')
      $this.addClass('animated')
    }
  }
}

$(window).load(function () {
  if ($('.counter_module').length) {
    $('.counter_module').each(function () {
      if (isScrolledIntoView($(this))) {
        counter($(this))
      }
    })
  }
})

$(window).scroll(function () {
  if ($('.counter_module').length) {
    $('.counter_module').each(function () {
      if (isScrolledIntoView($(this))) {
        counter($(this))
      }
    })
  }
})

$(window).resize(function () {
  if ($('.counter_module').length) {
    $('.counter_module').each(function () {
      $(this).find('.counter-input').removeClass('animated')
      if (isScrolledIntoView($(this))) {
        counter($(this))
      }
    })
  }
})
